import React from 'react'
import Slider from "react-slick"
import { Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8, Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15, Logo16, Logo17, Logo18, Logo19, Logo20, Logo21, Logo22, Logo23, Logo24, Logo25 } from '../assets/logo';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const Company = () => {
    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 500,
        cssEase: "linear"
      };
    return (
        <div className="mainContainer pt-16 overflow-x-hidden">
            <h2 className='font-bold text-4xl text-center text-primary my-16'>
                Perusahaan Telah Berkerjasama Dengan Kami
            </h2>
        <Slider {...settings} className='flex items-center justify-center mb-16'>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo1} className='w-full h-32 object-contain' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo2} className='w-full h-32 object-contain' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo3} className='w-full h-32 object-contain' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo4} className='w-full h-32 object-contain' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo5} className='w-full h-32 object-contain' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo6} className='w-full h-32 object-contain' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo7} className='w-full h-32 object-contain' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo8} className='w-full h-32 object-contain' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo9} className='w-full h-32 object-contain' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo10} className='w-ful h-32 object-containl' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo11} className='w-ful h-32 object-containl' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo12} className='w-ful h-32 object-containl' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo13} className='w-ful h-32 object-containl' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo14} className='w-ful h-32 object-containl' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo15} className='w-ful h-32 object-containl' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo16} className='w-ful h-32 object-containl' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo17} className='w-ful h-32 object-containl' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo18} className='w-ful h-32 object-containl' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo19} className='w-ful h-32 object-containl' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo20} className='w-ful h-32 object-containl' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo21} className='w-ful h-32 object-containl' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo22} className='w-ful h-32 object-containl' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo23} className='w-ful h-32 object-containl' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo24} className='w-ful h-32 object-containl' />
          </div>
          <div className="container flex items-center w-32 justify-center">
            <img src={Logo25} className='w-ful h-32 object-containl' />
          </div>
        </Slider>
      </div>
    )
}

export default Company